import { Capacitor } from '@capacitor/core';
import { environment } from '../../environments/environment';

export const NOISY_PODCASTER_PRODUCTION_API_BASE = 'https://noisypodcaster.wahl.website';

export function appApiBase(): string {
  const configuredBase = normalizeApiBase(environment.apiBase);
  if (Capacitor.getPlatform() !== 'web' && isLocalApiBase(configuredBase)) {
    return NOISY_PODCASTER_PRODUCTION_API_BASE;
  }

  return configuredBase || NOISY_PODCASTER_PRODUCTION_API_BASE;
}

export function apiRelativeUrl(url: string, base = appApiBase()): string {
  if (/^[a-z][a-z\d+\-.]*:/i.test(url)) {
    return url;
  }

  const apiRelativePath = url.startsWith('//') ? url.replace(/^\/+/, '/') : url;
  return new URL(apiRelativePath, base).toString();
}

function normalizeApiBase(value: unknown): string {
  return value?.toString().trim().replace(/\/+$/, '') || '';
}

function isLocalApiBase(value: string): boolean {
  if (!value) {
    return true;
  }

  try {
    const parsed = new URL(value);
    return ['localhost', '127.0.0.1', '0.0.0.0'].includes(parsed.hostname);
  } catch {
    return true;
  }
}
